import type { FunctionComponent } from "react"

import { Heading } from "@jobteaser/spark/components/Heading"
import { Text } from "@jobteaser/spark/components/Text"

import styles from "./Description.module.css"

type DescriptionProps = {
  titleLabel: string
  descriptionLabel: string
}

export const Description: FunctionComponent<DescriptionProps> = ({ titleLabel, descriptionLabel }) => {
  return (
    <div className={styles.main} data-testid="PrefilteredJobSearch-Description">
      <Heading as="h2" className={styles.title} variant="title3">
        {titleLabel}
      </Heading>
      <Text variant="body1">{descriptionLabel}</Text>
    </div>
  )
}
